import Api from 'libs/api';
import AuthService from 'services/Auth';

class MessageDialogApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/message_dialogs`);
  }
}

export default MessageDialogApi;
